import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-325e12a6"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "My-ECharts"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "left-top"
  }, null, -1);
});

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "left-bottom"
  }, null, -1);
});

var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "right-top"
  }, null, -1);
});

var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "right-bottom"
  }, null, -1);
});

var _hoisted_6 = {
  class: "top"
};

var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "left"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "line"
  }), /*#__PURE__*/_createElementVNode("div", {
    class: "title"
  }, " 网上考试 ")], -1);
});

var _hoisted_8 = {
  class: "right"
};

var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "total"
  }, "总数：", -1);
});

var _hoisted_10 = {
  class: "total"
};

var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "total"
  }, "（次）", -1);
});

var _hoisted_12 = {
  id: "examMain",
  ref: "eCharts",
  style: {
    "width": "100%",
    "height": "97%",
    "display": "flex",
    "align-items": "end"
  },
  class: "echarts-content"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _hoisted_3, _hoisted_4, _hoisted_5, _createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.total), 1), _hoisted_11])]), _createElementVNode("div", _hoisted_12, null, 512)]);
}